/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Common_Na1Inputs */

const id_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const ms_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const da_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const de_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/V`)
};

const en_us2_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const es_es2_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/D`)
};

const es_mx2_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/D`)
};

const fil_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const fr_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/D`)
};

const it_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/D`)
};

const hu_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const nl_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N.V.T.`)
};

const no_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I/T`)
};

const pl_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B/D`)
};

const pt_br2_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/D`)
};

const pt_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/D`)
};

const ro_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const fi_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E/O`)
};

const sv_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const vi_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const tr_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yok`)
};

const cs_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const bg_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const ru_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет данных`)
};

const uk_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Н/Д`)
};

const ar_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير متاح`)
};

const hi_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const th_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const ja_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const zh_cn2_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const zh_hant1_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const ko_offerdetail_common_na1 = /** @type {(inputs: Offerdetail_Common_Na1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

/**
* | output |
* | --- |
* | "N/A" |
*
* @param {Offerdetail_Common_Na1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_common_na1 = /** @type {((inputs?: Offerdetail_Common_Na1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Common_Na1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_common_na1(inputs)
	if (locale === "ms") return ms_offerdetail_common_na1(inputs)
	if (locale === "da") return da_offerdetail_common_na1(inputs)
	if (locale === "de") return de_offerdetail_common_na1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_common_na1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_common_na1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_common_na1(inputs)
	if (locale === "fil") return fil_offerdetail_common_na1(inputs)
	if (locale === "fr") return fr_offerdetail_common_na1(inputs)
	if (locale === "it") return it_offerdetail_common_na1(inputs)
	if (locale === "hu") return hu_offerdetail_common_na1(inputs)
	if (locale === "nl") return nl_offerdetail_common_na1(inputs)
	if (locale === "no") return no_offerdetail_common_na1(inputs)
	if (locale === "pl") return pl_offerdetail_common_na1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_common_na1(inputs)
	if (locale === "pt") return pt_offerdetail_common_na1(inputs)
	if (locale === "ro") return ro_offerdetail_common_na1(inputs)
	if (locale === "fi") return fi_offerdetail_common_na1(inputs)
	if (locale === "sv") return sv_offerdetail_common_na1(inputs)
	if (locale === "vi") return vi_offerdetail_common_na1(inputs)
	if (locale === "tr") return tr_offerdetail_common_na1(inputs)
	if (locale === "cs") return cs_offerdetail_common_na1(inputs)
	if (locale === "bg") return bg_offerdetail_common_na1(inputs)
	if (locale === "ru") return ru_offerdetail_common_na1(inputs)
	if (locale === "uk") return uk_offerdetail_common_na1(inputs)
	if (locale === "ar") return ar_offerdetail_common_na1(inputs)
	if (locale === "hi") return hi_offerdetail_common_na1(inputs)
	if (locale === "th") return th_offerdetail_common_na1(inputs)
	if (locale === "ja") return ja_offerdetail_common_na1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_common_na1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_common_na1(inputs)
	return ko_offerdetail_common_na1(inputs)
});
export { offerdetail_common_na1 as "offerDetail.common.na" }